// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.import-workbook-file-view__progress {
  --g-progress-filled-background-color: var(--g-color-base-brand);
}
.import-workbook-file-view__error-content {
  padding: 0;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/CollectionsStructure/CreateWorkbookDialog/ImportWorkbookView/ImportWorkbookView.scss"],"names":[],"mappings":"AACI;EACI,+DAAA;AAAR;AAGI;EACI,UAAA;AADR","sourcesContent":[".import-workbook-file-view__progress {\n  --g-progress-filled-background-color: var(--g-color-base-brand);\n}\n.import-workbook-file-view__error-content {\n  padding: 0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
